"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TypeToJSON = exports.TypeFromJSONTyped = exports.TypeFromJSON = exports.Type = void 0;
/**
 *
 * @export
 */
exports.Type = {
    AdAgency: 'AD_AGENCY',
    BrandAdvertiser: 'BRAND_ADVERTISER',
    MusicLabel: 'MUSIC_LABEL',
    ConcertPromoter: 'CONCERT_PROMOTER',
    Artist: 'ARTIST',
    Manager: 'MANAGER',
    Publisher: 'PUBLISHER',
    Internal: 'INTERNAL'
};
function TypeFromJSON(json) {
    return TypeFromJSONTyped(json, false);
}
exports.TypeFromJSON = TypeFromJSON;
function TypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.TypeFromJSONTyped = TypeFromJSONTyped;
function TypeToJSON(value) {
    return value;
}
exports.TypeToJSON = TypeToJSON;
